import React from 'react';
import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';

const TopContainer = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/reports/bill-history');
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.backWrap}>
          <button
            type="button"
            className={styles.backBtn}
            onClick={handleBack}
            aria-label="Back to Bill History"
          >
            <IoArrowBack size={20} />
            Back
          </button>
        </div>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle}>Bill Details</h1>
          <p className={styles.breadcrumb}>Reports / Bill History / Details</p>
        </div>
      </div>
    </div>
  );
};

export default TopContainer;
